<template>
  <nx-bform-group
    :label="requiredLabel(name)"
    v-bind="$attrs"
    :description="defaultDescription"
  >
    <slot>
      <nx-bform-input
        :name="name"
        :rules="{ required, regex: /^([A-Z]{1,2})([0-9]{6})\(([A0-9])\)$/}"
        :value="$attrs.value"
        @input="$listeners.input"
      />
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  props: {
    description: {
      type: String
    }
  },
  computed: {
    name() {
      return this.label || this.$t("hkidNumber");
    },
    defaultDescription() {
      return this.description === undefined
        ? this.$t("hkidNumberDesc")
        : this.description;
    }
  }
};
</script>

<i18n src="@/locales/registration.locale.json" />
